<div class="modal-container" *transloco="let t; prefix: 'driverDocuments'">
  <div class="modal-container__header">
    <span class="modal-container__header-title">{{ t('edit.title') }}</span>
    <button class="modal-container__header-btn" (click)="closeModal()" [title]="'common.close' | transloco">
      <svg class="modal-container__header-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.1959 6.34399L11.9529 10.586L7.71087 6.34399L6.29688 7.75799L10.5389 12L6.29688 16.242L7.71087 17.656L11.9529 13.414L16.1959 17.656L17.6099 16.242L13.3679 12L17.6099 7.75799L16.1959 6.34399Z" fill="#9FA1A4"/>
      </svg>
    </button>
  </div>
  <div class="modal-container__body">
    <div class="modal-form">
      <div class="modal-form__document-info">
        <label class="modal-label">{{ t('fields.documentName') }}</label>
        <input class="modal-input" type="text" placeholder="{{document.documentName | documentTypeLabel}}" [title]="t('fields.documentName')" readonly />
      </div>

      <div class="modal-upload-merged">
        <input type="file" accept=".pdf" hidden (change)="onFileSelected($event)" #fileInput />
        <input class="modal-input merged-input" [disabled]="uploadedDocument?.uploading || uploadedDocument?.uploadSuccess" type="text" value="{{file?.name || t('fields.selectFileToUpload')}}" [title]="t('fields.documentName')" readonly />
        <button class="modal-upload-btn merged-btn" [disabled]="uploadedDocument?.uploading || uploadedDocument?.uploadSuccess" [title]="t('actions.upload')" (click)="fileInput.click()">{{ t('actions.upload') }}</button>
      </div>

      @if (documentTypeExpires && uploadedDocument?.uploadSuccess) {
        <div class="modal-form__document-renewal">
          @if (documentTypeName === 'Drivers License' && !hasProfessionalDrivingPermit) {
            <div class="modal-toggle">
              <label class="switch">
                <input type="checkbox" [disabled]="hasLicensePdp && document.pdpValidUntil !== null" [(ngModel)]="hasLicensePdp" />
                <span class="slider round"></span>
              </label>
              <span>{{ t('fields.licenseContainsPdp') }}</span>
            </div>
          }
          @if (documentTypeExpires && !(documentTypeName === 'Drivers License' && hasLicensePdp)) {
            <div class="modal-form__document-renewal__date">
              <app-flatpickr-date-picker
                [label]="t('fields.renewalDateFor', { name: (document.documentName | documentTypeLabel) })"
                [(value)]="documentRenewalDate"
                [disabled]="!file || !uploadedDocument?.uploadSuccess">
              </app-flatpickr-date-picker>
            </div>
          }
          @if (document.documentName === 'Drivers License' && hasLicensePdp) {
            <div class="modal-form__document-renewal__date-row">
              <div class="modal-form__document-renewal__date">
                <app-flatpickr-date-picker
                  [label]="t('fields.renewalDateFor', { name: (document.documentName | documentTypeLabel) })"
                  [(value)]="documentRenewalDate"
                  [disabled]="!file">
                </app-flatpickr-date-picker>
              </div>
              <div class="modal-form__document-renewal__date">
                <app-flatpickr-date-picker
                  [label]="t('fields.pdpRenewalDate')"
                  [(value)]="licensePdpRenewalDate"
                  [disabled]="!file">
                </app-flatpickr-date-picker>
              </div>
            </div>
          }
        </div>
      }

      <!-- Upload Progress Bar -->
      @if (uploadedDocument && (uploadedDocument.uploading || uploadedDocument.uploadSuccess)) {
        <div class="upload-status">
          <div class="upload-status-info-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19.937 8.68C19.926 8.648 19.917 8.617 19.904 8.586C19.855 8.48 19.794 8.379 19.708 8.293L13.708 2.293C13.622 2.207 13.521 2.146 13.415 2.097C13.385 2.083 13.353 2.075 13.321 2.064C13.237 2.036 13.151 2.018 13.062 2.013C13.04 2.011 13.021 2 13 2H6C4.897 2 4 2.897 4 4V20C4 21.103 4.897 22 6 22H18C19.103 22 20 21.103 20 20V9C20 8.979 19.989 8.96 19.987 8.938C19.982 8.85 19.965 8.764 19.937 8.68ZM16.586 8H14V5.414L16.586 8ZM6 20V4H12V9C12 9.553 12.447 10 13 10H18L18.002 20H6Z" fill="#9FA1A4"/>
            </svg>
          </div>
          <div class="upload-status-info-text">
            <span>{{ document.documentName | documentTypeLabel }}</span>
            @if (uploadedDocument.uploading) {
              <div class="upload-status-progress-bar-container">
                <div class="upload-status-progress-bar" [style.width.%]="uploadedDocument.uploadProgress"></div>
              </div>
            }
            @if (uploadedDocument.uploadSuccess) {
              <div class="upload-status-success">
                {{ t('upload.fileUploaded') }}
              </div>
            }
          </div>
          @if (uploadedDocument.uploading) {
            <div class="upload-status-percentage">
              <span>{{ uploadedDocument.uploadProgress }}%</span>
            </div>
          }
          @if (uploadedDocument.uploadSuccess) {
            <div class="upload-status-delete-file">
              <button class="upload-status-delete-file-btn" (click)="openDeleteDriverDocumentConfirmationModal(document)" [title]="t('actions.deleteFile')">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 20C5 21.103 5.897 22 7 22H17C18.103 22 19 21.103 19 20V8H21V6H17V4C17 2.897 16.103 2 15 2H9C7.897 2 7 2.897 7 4V6H3V8H5V20ZM9 4H15V6H9V4ZM17 8L17.001 20H7V8H17Z" fill="#9FA1A4"/>
                  <path d="M9 10H11V18H9V10ZM13 10H15V18H13V10Z" fill="#9FA1A4"/>
                </svg>
              </button>
            </div>
          }
        </div>
      }

      <div class="modal-actions">
        <button class="modal-btn cancel" (click)="closeModal()">{{ 'common.cancel' | transloco }}</button>
        <button class="modal-btn save" (click)="saveChanges()"
          [disabled]="!file ||
          (uploadedDocument?.uploading || !uploadedDocument?.uploadSuccess) ||
          (documentTypeName === 'Drivers License' && hasLicensePdp && (documentRenewalDate === '' || licensePdpRenewalDate === '')) ||
          (documentTypeExpires && (documentRenewalDate === '') || isLoading)
        ">
          @if (isLoading) {
            <span class="spinner-border"></span>
          }
          @if (!isLoading) {
            <span>{{ 'common.saveChanges' | transloco }}</span>
          }
        </button>
      </div>
    </div>
  </div>